<template>
  <div>
    <div class="fb fb-cross-center fb-main-end" @click="handleChooseClass">
      <span class="c-171A1D mr-4 text-ellipsis inline-block current-class">{{
        cpCurrentClass.name || ''
      }}</span>
      <i v-if="cpClassList && cpClassList.length > 1" class="iconfont"
        >&#xe681;</i
      >
    </div>
  </div>
</template>

<script>
import mixin from '@/mixin'
import {} from '@/utils/comUtils'
import { LEAVE_ROLE } from '@/utils/constUtils'
export default {
  mixins: [mixin],
  components: {},
  props: {
    // 当前角色
    curRole: {
      type: Number,
      default: LEAVE_ROLE.headmaster
    },
    // 当前所选id
    tpClassId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // classList: this.$store.getters.classList, // 初始班级列表(角色为班主任时)
      // teacherClassList: this.$store.getters.teacherClassList, // 初始班级列表(角色为老师时)
      currentClass: null,
      classDingId: this.tpClassId || '',
      activeIndex: 0
    }
  },
  computed: {
    // 当前班级列表
    cpClassList() {
      /* eslint-disable */
      let _list =
        this.curRole === LEAVE_ROLE.headmaster
          ? this.classList
          : this.isTeacher
          ? this.teacherClassList
          : []
      return _list
      /* eslint-enable */
    },
    // 当前展示的班级对象
    cpCurrentClass() {
      let _currentClass =
        (this.cpClassList.filter(item => {
          return item.tpId === this.classDingId
        }) || [])[0] || this.cpClassList[0]
      return this.currentClass || _currentClass || {}
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.$emit('getClass', this.cpCurrentClass.tpId, this.cpCurrentClass)
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    //  选择班级
    async handleChooseClass() {
      if (+this.cpClassList.length <= 1) {
        return false
      }
      let _list = this.cpClassList.map(item => {
        return {
          tpId: item.tpId,
          name: item.name
        }
      })
      this.activeIndex = Math.max(
        _list.findIndex(item => {
          return item.tpId === this.classDingId
        }),
        0
      )
      const _this = this
      this.$Picker({
        $props: {
          columns: _list,
          defaultActive: this.activeIndex
        },
        $events: {
          confirm(index, selectedClass) {
            _this.activeIndex = index[0]
            _this.classDingId = selectedClass[0].tpId
            _this.currentClass =
              _list.find(data => data.tpId === _this.classDingId) || {}
            _this.$emit('getClass', _this.classDingId, _this.currentClass)
          }
        }
      }).show()
    }
  }
}
</script>

<style lang="scss" scoped>
.current-class {
  max-width: 200px;
}
</style>
